(() => {
  if (window.FabrikoneCompactInformation) return;
  const active = new Map();
  let reviews = null;
  let scheduled = false;
  const panelsFor = root => [...root.querySelectorAll(':scope > .fab-information-items > [data-fab-information-panel]')];
  const sync = root => {
    root.querySelectorAll('[data-fab-information-button]').forEach(button => {
      const panel = panelsFor(root).find(item => item.dataset.fabInformationPanel === button.dataset.fabInformationButton);
      button.setAttribute('aria-expanded', String(Boolean(panel?.open)));
      button.classList.toggle('is-active', Boolean(panel?.open));
    });
  };
  const select = (root, target, opened = true) => {
    panelsFor(root).forEach(panel => { panel.open = panel === target && opened; });
    sync(root);
  };
  const mountReviews = () => {
    const current = document.querySelector('[data-fab-native-reviews]');
    if (current && current !== reviews) reviews = current;
    if (!reviews) return;
    const root = [...document.querySelectorAll('[data-fab-information]')].find(item => item.dataset.productId === reviews.dataset.reviewProduct);
    const mount = root?.querySelector('[data-fab-reviews-mount]');
    if (mount && reviews.parentElement !== mount) mount.append(reviews);
  };
  const resolveHash = (hash, scroll = true) => {
    let id;
    try { id = decodeURIComponent(hash.replace(/^#/, '')); } catch { return; }
    if (!id) return;
    mountReviews();
    const target = document.getElementById(id);
    if (!target) return;
    const root = target.closest('[data-fab-information]');
    const panel = target.closest('[data-fab-information-panel]');
    if (!root || !panel) return;
    select(root, panel);
    let nested = target instanceof HTMLDetailsElement ? target : target.closest('details');
    while (nested && nested !== panel) {
      nested.open = true;
      nested = nested.parentElement?.closest('details');
    }
    if (scroll) requestAnimationFrame(() => target.scrollIntoView({block: 'start', behavior: 'auto'}));
  };
  const initialize = root => {
    if (active.has(root)) return;
    const controller = new AbortController();
    active.set(root, controller);
    root.querySelectorAll('[data-fab-information-button]').forEach(button => {
      button.addEventListener('click', () => {
        const target = panelsFor(root).find(panel => panel.dataset.fabInformationPanel === button.dataset.fabInformationButton);
        if (target) select(root, target, !target.open);
      }, {signal: controller.signal});
    });
    panelsFor(root).forEach(panel => {
      panel.addEventListener('toggle', () => {
        if (panel.open) select(root, panel);
        else sync(root);
      }, {signal: controller.signal});
    });
    root.querySelector('.fab-information-tabs')?.addEventListener('keydown', event => {
      const buttons = [...root.querySelectorAll('[data-fab-information-button]')];
      const index = buttons.indexOf(event.target.closest('button'));
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) { event.preventDefault(); buttons[next].focus(); }
    }, {signal: controller.signal});
    sync(root);
  };
  const scan = () => {
    scheduled = false;
    active.forEach((controller, root) => {
      if (!root.isConnected) { controller.abort(); active.delete(root); }
    });
    document.querySelectorAll('[data-fab-information]').forEach(initialize);
    mountReviews();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(scan);
  };
  const start = () => {
    scan();
    resolveHash(window.location.hash);
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch { return; }
    if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash) resolveHash(url.hash);
  });
  window.addEventListener('hashchange', () => resolveHash(window.location.hash));
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('product:updated', schedule);
  window.FabrikoneCompactInformation = {refresh: scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
